import '../login/main.scss';
import Rails from 'rails-ujs';

try {
  Rails.start();
} catch (error) {
  if (error?.message !== 'rails-ujs has already been loaded!') throw error;
}
